import { Image, Col, Row } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement, useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const SingleBanner = ({
  BannerDetails,
}: {
  BannerDetails: any;
}): ReactElement => {
  const [getBannerDetails, setBannerDetails] = useState(undefined);

  useEffect(() => {
    setBannerDetails(BannerDetails);
  }, [BannerDetails]);

  return (
    <React.Fragment>
      <Row gutter={20}>
        <Col span={24}>
          <Image src={getBannerDetails?.bannerImage} className="rounded" />
        </Col>
        <Col span={24}>
          <h3 className="title mt-4">Basic Information</h3>
          <div className="inner-body-wrapper">
            <div className="inner-body">
              <div className="single">
                <div className="info-name">
                  <span>Banner Title</span>
                </div>
                <div className="info-desc">
                  <span>{getBannerDetails?.bannerName}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Position</span>
                </div>
                <div className="info-desc">
                  <span>{getBannerDetails?.bannerPosition}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Type</span>
                </div>

                <div className="info-desc">
                  <span>{`${getBannerDetails?.type?.replace("_", " ")}`}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Status</span>
                </div>
                <div className="info-desc">
                  <span
                    className={`radius-btn ${
                      !getBannerDetails?.deleted ? "active" : "inactive"
                    }-btn`}
                  >
                    {!getBannerDetails?.deleted ? "Active" : "Inactive"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};
SingleBanner.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default SingleBanner;
